'use client';

import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import type { FC } from 'react';
import { useFormStatus } from 'react-dom';

import { i18n } from '../../i18n';

type SubmitButtonProps = {
  'data-testid'?: string;
  label?: string;
  loading?: boolean;
};

export const SubmitButton: FC<SubmitButtonProps> = ({
  'data-testid': dataTestId = 'button-submit',
  label = i18n.form.submit,
  loading,
}) => {
  const { pending } = useFormStatus();

  return (
    <BoxCTA as="button" data-testid={dataTestId} loading={loading || pending} type="submit">
      {label}
    </BoxCTA>
  );
};
